<template>
  <Category :key="slug" />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  import Category from '@/pages/seoCategoryListing/Category.vue';

  const route = useRoute();

  const slug = computed(() => {
    return route?.params?.categorySlug as string;
  });
</script>
